import classNames from 'classnames';
import { ReactNode, useEffect, useRef } from 'react';
import { config, getAssetUrl } from '../../../utils/config';
import useClickOutside from '../../../utils/useClickOutside';
import useIsMobileDevice from '../../../utils/useIsMobileDevice';
import './style.scss';

export type ModalProps = {
  children: ReactNode;
  isDifferentTree?: boolean;
  contentClassName?: string;
  backgroundClassName?: string;
  onClickOutside?: () => void;
  onClose?: () => void;
  onEscapeKey?: () => void;
};

const Modal = ({ children, isDifferentTree, onClickOutside, onClose, onEscapeKey, ...props }: ModalProps) => {
  const { desktopHeight, mobileHeight } = config.header;
  const isMobile = useIsMobileDevice();
  const containerRef = useRef<HTMLDivElement>(null);

  useClickOutside(containerRef, true, () => {
    if (!onClickOutside || isDifferentTree) {
      return;
    }

    onClickOutside();
  });

  useEffect(() => {
    const keyDownHandler = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        onEscapeKey?.();
      }
    };
    document.body.style.overflow = 'hidden';
    window.addEventListener('keydown', keyDownHandler);

    return () => {
      document.body.style.overflow = 'auto';
      window.removeEventListener('keydown', keyDownHandler);
    };
  }, []);

  return (
    <div className={classNames('modal', props.backgroundClassName)}>
      <div
        ref={containerRef}
        className={classNames('modal__content', props.contentClassName)}
        style={{ marginTop: isMobile ? mobileHeight : desktopHeight }}
      >
        {onClose && (
          <img
            className="modal__close"
            src={getAssetUrl('common/remove.svg')}
            onClick={onClose}
            data-test-id="modal-close-icon"
          />
        )}
        {children}
      </div>
    </div>
  );
};

export default Modal;
